import actions from './actions'

const authOperations = {
  trackingInit: actions.trackingInit,
  trackEvent: actions.trackEvent,
}

export default authOperations
